import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { AREAS, BUSINESS, SERVICES } from "@/lib/site";

const FooterLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="text-[15px] text-white/75 transition-colors duration-200 hover:text-white">
      {children}
    </Link>
  </li>
);

export const Footer = () => {
  const { address } = BUSINESS;
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="container-site grid gap-12 py-16 md:grid-cols-2 md:py-20 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <Link to="/" data-testid="footer-logo-link" aria-label="DMS Home Improvements home" className="inline-block rounded-card bg-white p-3">
            <img src="/images/dms-home-improvements-logo.webp" alt="DMS Home Improvements logo" width="150" height="53" loading="lazy" className="h-auto w-[150px]" />
          </Link>
          <p className="mt-5 max-w-[320px] text-[15px] text-white/75">
            Family-run builders and plasterers serving Molesey, Kingston and South West London for over 20 years.
          </p>
        </div>

        <nav aria-labelledby="footer-services">
          <h3 id="footer-services" className="text-base font-semibold uppercase tracking-[0.08em] text-white">
            Services
          </h3>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <FooterLink key={s.id} to={s.to} testId={`footer-service-${s.id}`}>
                {s.title} in Molesey & Kingston
              </FooterLink>
            ))}
          </ul>
        </nav>

        <nav aria-labelledby="footer-areas">
          <h3 id="footer-areas" className="text-base font-semibold uppercase tracking-[0.08em] text-white">
            Areas
          </h3>
          <ul className="mt-5 space-y-3">
            {AREAS.map((a) => (
              <FooterLink key={a.id} to={a.to} testId={`footer-area-${a.id}`}>
                Builders in {a.name}
              </FooterLink>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-white">Contact</h3>
          <address className="mt-5 space-y-4 text-[15px] not-italic text-white/75">
            <p className="flex items-start gap-3">
              <MapPin size={18} className="mt-1 shrink-0 text-brand" aria-hidden="true" />
              <span data-testid="footer-address">
                {BUSINESS.name}
                <br />
                {address.locality}, {address.region} {address.postcode}
              </span>
            </p>
            <p className="flex items-center gap-3">
              <Phone size={18} className="shrink-0 text-brand" aria-hidden="true" />
              <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="font-semibold text-white transition-colors hover:text-brand">
                {BUSINESS.phone}
              </a>
            </p>
            <p className="flex items-center gap-3">
              <Mail size={18} className="shrink-0 text-brand" aria-hidden="true" />
              <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email-link" className="transition-colors hover:text-white">
                {BUSINESS.email}
              </a>
            </p>
            <p className="flex items-start gap-3">
              <Clock size={18} className="mt-1 shrink-0 text-brand" aria-hidden="true" />
              <span data-testid="footer-hours">{BUSINESS.hours}</span>
            </p>
            <p className="text-sm text-white/55" data-testid="footer-company-number">
              Company No. {BUSINESS.companyNumber}
            </p>
          </address>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site flex flex-col gap-2 py-5 text-sm text-white/55 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© DMS Home Improvements 2026</p>
          <p>Builders & plasterers in Molesey, Surrey</p>
        </div>
      </div>
    </footer>
  );
};
